/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum LoanGrouping {
    NewAutomobile = "NewAutomobile",
    UsedAutomobile = "UsedAutomobile",
    RefinancedAutomobile = "RefinancedAutomobile",
    NewMotorcycle = "NewMotorcycle",
    UsedMotorcycle = "UsedMotorcycle",
    RefinancedMotorcycle = "RefinancedMotorcycle",
    NewPremierMotorcycle = "NewPremierMotorcycle",
    UsedPremierMotorcycle = "UsedPremierMotorcycle",
    RefinancedPremierMotorcycle = "RefinancedPremierMotorcycle",
    NewRecreationalVehicle = "NewRecreationalVehicle",
    UsedRecreationalVehicle = "UsedRecreationalVehicle",
    RefinancedRecreationalVehicle = "RefinancedRecreationalVehicle",
    NewTrailer = "NewTrailer",
    UsedTrailer = "UsedTrailer",
    RefinancedTrailer = "RefinancedTrailer",
    NewWatercraft = "NewWatercraft",
    UsedWatercraft = "UsedWatercraft",
    RefinancedWatercraft = "RefinancedWatercraft",
    NewMortgage = "NewMortgage",
    RefinancedMortgage = "RefinancedMortgage",
    HELOC = "HELOC",
    HELOAN = "HELOAN",
    Personal = "Personal",
    Student = "Student",
    CreditCard = "CreditCard",
    Other = "Other",
    AccountOrigination = "AccountOrigination",
    CrossSell = "CrossSell",
    Payoff = "Payoff",
    NewATV = "NewATV",
    UsedATV = "UsedATV",
    RefinancedATV = "RefinancedATV",
    NewSnowmobile = "NewSnowmobile",
    UsedSnowmobile = "UsedSnowmobile",
    RefinancedSnowmobile = "RefinancedSnowmobile",
    NewTruckCamper = "NewTruckCamper",
    UsedTruckCamper = "UsedTruckCamper",
    RefinancedTruckCamper = "RefinancedTruckCamper",
    NewUTV = "NewUTV",
    UsedUTV = "UsedUTV",
    RefinancedUTV = "RefinancedUTV",
    NewJetski = "NewJetski",
    UsedJetski = "UsedJetski",
    RefinancedJetski = "RefinancedJetski",
}
